/**
 * src/components/analytics/GoogleAnalytics.tsx
 *
 * GA4 yükleyici — gtag.js'i YALNIZCA analytics onayı verilince enjekte eder
 * (kvkk-compliance.md: onaysız analitik çerez yok). Onay yoksa / GA_ID boşsa
 * hiçbir şey render etmez.
 *
 * SPA gezinme takibi: send_page_view ilk yüklemede otomatik; sonraki client
 * route değişimleri usePathname ile manuel page_view gönderir (ilk render atlanır,
 * çift sayım önlenir).
 *
 * Client Component.
 */

'use client'

import Script from 'next/script'
import { usePathname } from 'next/navigation'
import { useEffect, useRef } from 'react'

import { GA_ENABLED, GA_ID, pageview } from '@/lib/analytics/gtag'
import { useConsent } from '@/components/consent/ConsentProvider'

/**
 * GoogleAnalytics — consent-gated GA4 script + SPA page_view takibi.
 */
export function GoogleAnalytics() {
  const { consent } = useConsent()
  const pathname = usePathname()
  const firstRun = useRef(true)
  const analyticsOn = GA_ENABLED && consent?.analytics === true

  useEffect(() => {
    if (!analyticsOn) return
    // İlk çalıştırma: config'in gönderdiği initial page_view ile çakışmasın.
    if (firstRun.current) {
      firstRun.current = false
      return
    }
    pageview(pathname)
  }, [analyticsOn, pathname])

  if (!analyticsOn) return null

  return (
    <>
      <Script
        src={`https://www.googletagmanager.com/gtag/js?id=${GA_ID}`}
        strategy="afterInteractive"
      />
      <Script id="ga-init" strategy="afterInteractive">
        {`window.dataLayer=window.dataLayer||[];function gtag(){dataLayer.push(arguments);}window.gtag=gtag;gtag('js',new Date());gtag('consent','default',{analytics_storage:'granted'});gtag('config','${GA_ID}',{anonymize_ip:true});`}
      </Script>
    </>
  )
}
